<ccl-page-header>
    <div class="s-page-header__left c-page-header__left">
        <div class="c-title c-title--secondary text-capitalize">
            {{baseUrl}}
        </div>
    </div>
</ccl-page-header>

<ccl-content-section>
    <div class="c-title--subsection text-uppercase">
        Layout
    </div>
    <div class="row row--builder">
        <div class="col col--builder">
            <ccl-page-section-builder [model]="builderService.currentSite.pages[builderService.currentPageKey].content"></ccl-page-section-builder>
        </div>
    </div>
</ccl-content-section>